import useIEHelper from '@/commons/ie-helper'
const { URLSearchParamsWrapper } = useIEHelper()

const EXPLICIT_LOCALE_KEY = 'IDONIA_explicit_locale'

export function markExplicitLocale (code) {
  try {
    window.sessionStorage.setItem(EXPLICIT_LOCALE_KEY, code)
  } catch (e) {
  }
}

export function getExplicitLocale () {
  try {
    return window.sessionStorage.getItem(EXPLICIT_LOCALE_KEY) || ''
  } catch (e) {
    return ''
  }
}

export default {
  data () {
    return {
      urlParams: null
    }
  },
  computed: {
    locale () {
      return this.$root.$i18n.locale
    }
  },
  beforeMount () {
    this.urlParams = URLSearchParamsWrapper(window.location.search)
  },
  methods: {
    hl () {
      this.urlParams = URLSearchParamsWrapper(window.location.search)
      if (this.urlParams.get('hl')) {
        this.$log.log('hl from params: ', this.urlParams.get('hl'))
        return this.urlParams.get('hl')
      } else {
        this.setLocale(this.$i18n.locale)
        this.$log.log('hl from i18n: ', this.$i18n.locale)
        return this.$i18n.locale
      }
    },
    setLocale (code) {
      if (typeof code === 'object') {
        code = code.code
      }
      let url = window.location.href.split('?')[0]
      let query = window.location.href.split('?')[1] ? '' + window.location.href.split('?')[1] : ''
      query = query !== '' ? query.split('&') : []
      query = query.map(item => {
        if (item.split('=')[0] === 'hl') {
          return 'hl=' + code
        }
        return item
      })
      if (!query.includes('hl=' + code)) {
        query.push('hl=' + code)
      }
      query = '?' + query.join('&')
      window.history.replaceState(null, '', url + query)
      this.$i18n.locale = code
    }
  }
}
